export default {
  objective: 'Объектив',
  searchByNameOrAddress: 'Поиск по названию или адресу объекта',
  stage: 'Этап',
  checkin: 'Отметиться',
  youCheckedIn: 'Вы отмечены',
  direction: 'Маршрут',
  requestedCardsCount: 'Запрошенные объектные карты',
  answeredCardsCount: 'Отвеченные объектные карты',
  shippedCardsCount: 'Запущенные объектные карты',
  floorCount: 'Количество этажей',
  squareFloor: 'Площадь полов',
  squareRoof: 'Площадь кровли',
  squareOuterWalls: 'Площадь фасада',
  squareInnerWalls: 'Площадь внутренних стен',
  websiteConstruction: 'Вебсайт объекта',
  phasesNumber: 'Количество очередей',
  undergroundFloorsCount: 'Количество подземных этажей',
  placeOnMap: 'Место на карте',
  specifyPlaceOnMap: 'Укажите место на карте',
  moveMapToPoint: 'Передвиньте карту, чтобы метка указала на новое место',
  moveMapToPointMeeting: 'Укажите на карте место вашей встречи',
  addContractor: 'Добавить подрядчика',
  addNewConstruction: 'Добавить новый объект',
  myLocation: 'Мое местоположение',
  newLocation: 'Новое местоположение',
  placemark: 'Метка',
  youAreCheckedOut: 'Вы отметились на карте',
  chooseAppToConstructRoute: 'Выберите приложение для построения маршрута',
  noContractors: 'На данном объекте нет подрядчиков',
  noContractorsInStage: 'На данном этапе нет подрядчиков',
  emptyPhotoList: 'На данном объекте нет фото',
  emptyDocumentList: 'На данном объекте нет документов',
  noStages: 'На данном объекте нет этапов',
  noFoundGeoObjects: 'По вашему запросу ничего не было найдено',
  editStage: 'Редактирование этапа',
  addGeoObjectSuccess: 'Новый объект добавлен',
  addMeetingObjectSuccess: 'Новый визит зафиксирован',
  editGeoObjectSuccess: 'Объект изменен',
  openedStage: 'Открыт',
  closedStage: 'Закрыт',
  fetchingListOfGeoObjects: 'Получение списка объектов...',
  zoomIn: 'Приблизить',
  zoomOut: 'Отдалить',
  promiseLongOperation: 'Создание нового обещания займет некоторое время',
  clientVisits: 'Мои встречи с клиентами',
  visit: 'Визит',
  startConstruction: 'Начало строительства',
  endConstruction: 'Окончание строительства',
};
